import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth now uses HttpOnly cookies set by the backend on /auth/login.
// All requests must send credentials so the cookie travels with them.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Endpoints that may legitimately return 401 without it meaning the user's
// existing session has expired (login attempts, session probe, password change).
const AUTH_PROBE_SUBSTRINGS = ["/auth/login", "/auth/me", "/auth/change-password"];

// Global guard so a burst of parallel 401s only produces a single toast + redirect.
let sessionExpiredHandled = false;

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const isAuthProbe = AUTH_PROBE_SUBSTRINGS.some((p) => url.includes(p));

    if (status === 401 && !isAuthProbe && typeof window !== "undefined") {
      const onLoginPage = window.location.pathname.startsWith("/login");
      if (!sessionExpiredHandled && !onLoginPage) {
        sessionExpiredHandled = true;
        try {
          toast.error("Sessione scaduta. Effettua di nuovo l'accesso.");
        } catch (_) {
          // toast may not be mounted yet; ignore.
        }
        window.dispatchEvent(new CustomEvent("auth:unauthorized"));
        setTimeout(() => {
          const redirectTarget = `/login?next=${encodeURIComponent(
            window.location.pathname + window.location.search
          )}`;
          window.location.assign(redirectTarget);
        }, 400);
      }
      // While the page is about to navigate away, swallow the error by returning
      // a never-settling promise. This prevents unhandled-rejection overlays
      // (e.g. CRA's red error screen) from flashing during the redirect.
      if (!onLoginPage) {
        return new Promise(() => {});
      }
    }

    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
